<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  async created() {
    try {
      const token =
        this.$store.getters["userVUEX/getToken"] ||
        localStorage.getItem("vue_token");

      if (token) {
        await this.$store.dispatch("userVUEX/getUserData");
      }
    } catch (error) {
      console.error(error);
    }
    this.listenForSignout();
  },
  methods: {
    async listenForSignout() {
      this.$socket.on("signedOut", (data) => {
        alert(data.message); // Log or handle the signed-out message as needed
        localStorage.clear();
        this.$store.dispatch("userVUEX/LogOut");
        this.$router.push(`/login?redirect=${this.$route.fullPath}`);
      });
    },
  },
};
</script>
<style>
::placeholder {
  /* font-weight: 400;
  font-size: 14px;
  font-family: "Montserrat", sans-serif;
  color: #667085; */
  font-weight: 400;
  font-size: 12px;
  line-height: 21px;
  color: #adaaaa !important;
  font-family: "Montserrat", sans-serif;
}
</style>
